import { Event, Identifiable, List, Project } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedEvent, Linker } from "../linkers/types";
import { mapError } from "../utils/mapError";

function saveEvent(httpClient: HttpClient, linker: Linker) {
  return (
    project: Identifiable<Project>,
    list: Identifiable<List>,
    { startTime, endTime, ...event }: Event,
  ) =>
    httpClient
      .sendHttpRequest<LinkedEvent>({
        endpoint: `/events`,
        method: HttpMethods.POST,
        data: {
          name: event.name,
          description: event.description,
          ...(event.keyRank !== -1 && {
            keyRank: event.keyRank,
          }),
          ...(startTime && { startTime }),
          ...(endTime && { endTime }),
          parentActivity: `/activities/${list.uuid}`,
          organizer: `/resources/${event.organizer.uuid}`,
          ...(event.location && {
            location: `/resources/${event.location.uuid}`,
          }),
          project: `/projects/${project.uuid}`,
          participants: event.participants.map(
            ({ uuid }) => `/resources/${uuid}`,
          ),
          ...(!!event.attributes && { attributes: event.attributes }),
        },
      })
      .then(linker.linkEvent)
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            emptyName: "emptyName",
            duplicateName: "duplicateName",
            invalidDateRange: "invalidDateRange",
            startDateOutOfBound: "startDateOutOfBound",
            listNotFound: "listNotFound",
          }),
        ),
      );
}

export { saveEvent };
